exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports
exports.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Nunito:300,400,500,600|Source+Sans+Pro:300,400,500,600,700,800,900);", ""]);
exports.i(require("-!../../../../node_modules/css-loader/index.js!antd/dist/antd.css"), "");

// module
exports.push([module.id, ".spinner {\n  width: 100%;\n  text-align: center;\n  height: auto;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 3.5rem; }\n  .spinner .ant-spin-dot i {\n    background: #8b3187; }\n\n.spinner.h-md {\n  min-height: 50vh; }\n\n.spinner.h-lg {\n  min-height: 80vh; }\n\n.spinner-fixed {\n  width: 20px;\n  height: 20px; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/lib/loader.js?sourceMap=true!./src/components/Shared/Spinner/Spinner.scss
// module id = 1439
// module chunks = 0